// Process [@mention](mention://user/1/Pranav)
import { parseMentionUri } from '../mention';

const buildMentionTokens = () => (state, silent) => {
  var label;
  var labelEnd;
  var labelStart;
  var pos;
  var res;
  var token;
  var href = '';
  var max = state.posMax;

  if (state.src.charCodeAt(state.pos) !== 0x5b /* [ */) {
    return false;
  }

  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) {
    return false;
  }

  label = state.src.slice(labelStart, labelEnd);
  pos = labelEnd + 1;

  if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
    pos += 1;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok && state.src.charCodeAt(res.pos) === 0x29 /* ) */) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    } else {
      return false;
    }
    pos += 1;
  }

  const mention = parseMentionUri(href);
  if (!mention) {
    return false;
  }

  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token = state.push('mention', '');
    token.href = href;
    token.content = state.md.utils.unescapeAll(label);
    token.mention = mention;
  }

  state.pos = pos;
  state.posMax = max;

  return true;
};

// The label is raw source text; escape it so a mention can't smuggle HTML past `html: false`.
const renderMentions = md => (tokens, idx) => {
  return `<span class="prosemirror-mention-node">${md.utils.escapeHtml(tokens[idx].content)}</span>`;
};

export default function mentionPlugin(md) {
  md.renderer.rules.mention = renderMentions(md);
  md.inline.ruler.before('link', 'mention', buildMentionTokens(md));
}
